// extracted by mini-css-extract-plugin
export default {"no-preview":"no-preview--FXz6z"};